import { NivelI } from "interfaces/Nivel";
import { ReactNode, useState } from "react";

interface Props {
  elemento: NivelI;
  renderActions?: (elemento: NivelI) => ReactNode;
}

export const NivelRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
